export default __webpack_public_path__ + "0d69985ed3670c2d18983fbcee9bf7ae.png";